import React, { useContext } from 'react';
// import { QuantaConfigContext } from '../../../../../lib/config/ConfigProvider';

import {
  Modal,
  DataGridGroup,
  Text,
  useResponsiveParams,
} from 'quanta-ui';
import { CurrencyFormater, QuantaConfigContext } from 'quanta-flows';

export default function ModalViewBreakup({
  showViewBreakup,
  setShowViewBreakup,
  selectedPlanTypeView,
  productName,
  quoteData,
  planData,
  title,
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const { branding } = useContext(QuantaConfigContext);

  const selectedPlan = planData?.plans?.find(
    (plan) => plan.name === selectedPlanTypeView,
  );
  let viewpremium = selectedPlan?.premium ?
  selectedPlan?.premium
  : 1000
  let GSTamount = viewpremium - (viewpremium * (100 / (100 +18 ) ) )
  let viewnetpremium = viewpremium - GSTamount
  // const resolveGender = (code) =>
  //   genderList.find(
  //     (gender) => gender?.code?.toLowerCase() === code?.toLowerCase(),
  //   ).value;

  const display_data = [
    {
      grid_data: [
        {
          colSpan: repeat,
          text: (
            <Text type="subheading" severity="info">
              {productName}, {selectedPlanTypeView}
            </Text>
          ),
        },
      ],
    },
    {
      grid_data: [
        //{ label: 'Cover Type', text: quoteData?.cover?.type },
        {
          label: 'Sum Insured',
          text: CurrencyFormater(quoteData?.cover?.sum_insured),
        },
        { label: 'Tenure', text: quoteData?.cover?.tenure },
      ],
    },
    {
      grid_data:
        selectedPlan && selectedPlan.premium
          ? [
            {
              text: <Text type="normal"></Text>,
              severity: 'info',
              colSpan: repeat === repeatForMobile ? 1 : 2,
            },
            {
              text: (
                <Text
                  type="normal"
                  className="flex justify-end mr-4"
                >
                  Premium ({branding?.currency})
                </Text>
              ),
              severity: 'info',
              colSpan: 1,
            },
            // ...selectedPlan?.premium?.breakup
            //   .map((mem, idx) => {
            //     return [
            //       {
            //         text: `${mem.relationship}, ${resolveGender(
            //           mem.gender,
            //         )}, ${mem.age}`,
            //         colSpan: repeat === repeatForMobile ? 1 : 2,
            //         type: 'normal',
            //       },
            //       {
            //         text: (
            //           <Text className="flex justify-end mr-4">
            //             {CurrencyFormater(mem.premium, false)}
            //           </Text>
            //         ),
            //         colSpan: 1,
            //         type: 'normal',
            //       },
            //     ];
            //   })
            //   .reduce((b, a) => [...b, ...a]),
            {
              text: <Text type="normal">Total Amount</Text>,
              severity: 'normal',
              colSpan: repeat === repeatForMobile ? 1 : 2,
            },
            {
              text: (
                <Text type="normal" className="flex justify-end mr-4">
                  {CurrencyFormater(
                      (selectedPlan && selectedPlan.premium
                        ? selectedPlan.premium.netPremium
                        : 0) || (viewpremium),
                    false,
                  )}
                </Text>
              ),
              severity: 'info',
              colSpan: 1,
            },
          ]
          : [
            {
              text: <Text type="title">Members</Text>,
              colSpan: repeat === repeatForMobile ? 1 : 2,
              severity: 'info',
            },
            {
              text: <Text type="title">Premium</Text>,
              colSpan: 1,
              severity: 'info',
            },
          ],
    },
    // {
    //   grid_data:
    //     selectedPlan &&
    //     selectedPlan?.premium 
    //     &&
    //     selectedPlan?.premium?.loading?.length > 0
    //       ? [
    //     // {
    //     //         text: <Text type="normal">Loadings</Text>,
    //     //         severity: 'info',
    //     //         colSpan: repeat === repeatForMobile ? 1 : 2,
    //     //       },
    //           {
    //             text: (
    //               <Text
    //                 type="normal"
    //                 className="flex justify-end mr-4"
    //               >
    //                 Amount ({branding.currency})
    //               </Text>
    //             ),
    //             severity: 'info',
    //             colSpan: 1,
    //           },
    //           ...selectedPlan.premium.loading
    //             .map((loading, idx) => {
    //               return [
    //                 {
    //                   text: `${loading.name}`,
    //                   colSpan: repeat === repeatForMobile ? 1 : 2,
    //                   type: 'normal',
    //                 },
    //                 {
    //                   text: (
    //                     <Text className="flex justify-end mr-4">
    //                       {CurrencyFormater(loading.amount, false)}
    //                     </Text>
    //                   ),
    //                   colSpan: 1,
    //                   type: 'normal',
    //                 },
    //               ];
    //             })
    //             .reduce((b, a) => [...b, ...a]),
    //         ]
    //       : [
    //           {
    //             text: <Text type="normal">Loading</Text>,
    //             severity: 'info',
    //             colSpan: repeat === repeatForMobile ? 1 : 2,
    //           },
    //           {
    //             text: (
    //               <Text
    //                 type="normal"
    //                 className="flex justify-end mr-4"
    //               >
    //                 {CurrencyFormater(0, false)}
    //               </Text>
    //             ),
    //             severity: 'info',
    //             colSpan: 1,
    //           },
    //         ],
    // },
    // {
    //   grid_data:
    //     selectedPlan &&
    //     selectedPlan.premium &&
    //     selectedPlan?.premium?.discount?.length > 0
    //       ? [
    //           {
    //             text: <Text type="normal">Discounts</Text>,
    //             severity: 'info',
    //             colSpan: repeat === repeatForMobile ? 1 : 2,
    //           },
    //           {
    //             text: (
    //               <Text
    //                 type="normal"
    //                 className="flex justify-end mr-4"
    //               >
    //                 Amount ({branding.currency})
    //               </Text>
    //             ),
    //             severity: 'info',
    //             colSpan: 1,
    //           },
    //           ...selectedPlan.premium.discount
    //             .map((discount, idx) => {
    //               return [
    //                 {
    //                   text: `${discount.name}`,
    //                   colSpan: repeat === repeatForMobile ? 1 : 2,
    //                   type: 'normal',
    //                 },
    //                 {
    //                   text: (
    //                     <Text className="flex justify-end mr-4">
    //                       {CurrencyFormater(discount.amount, false)}
    //                     </Text>
    //                   ),
    //                   colSpan: 1,
    //                   type: 'normal',
    //                 },
    //               ];
    //             })
    //             .reduce((b, a) => [...b, ...a]),
    //         ]
    //       : [
    //           {
    //       text: <Text type="normal">Discount</Text>,
    //       severity: 'info',
    //       colSpan: repeat === repeatForMobile ? 1 : 2,
    //     },
    //     {
    //       text: (
    //               <Text
    //                 type="normal"
    //                 className="flex justify-end mr-4"
    //               >
    //                 {CurrencyFormater(0, false)}
    //         </Text>
    //       ),
    //       severity: 'info',
    //       colSpan: 1,
    //     },
    //   ],
    // },
    {
      grid_data: [
        {
          text: <Text type="normal">Net Premium</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                (selectedPlan && selectedPlan?.premium
                  ? selectedPlan?.premium?.netPremium
                  : 0) || viewnetpremium,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="normal">GST/Tax</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                (selectedPlan && selectedPlan?.premium
                  ? selectedPlan?.premium?.gst
                  : 0) || GSTamount,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="subheading">Total Premium</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="subheading" className="flex justify-end mr-4">
              {CurrencyFormater(
                (selectedPlan && selectedPlan?.premium
                  ? selectedPlan?.premium?.totalPremium
                  : 0) || viewpremium,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
      ],
    },
  ];

  return selectedPlan ? (
    <div className="text-black font-normal">
      <Modal
        display={showViewBreakup}
        size={repeat === repeatForMobile ? 'full' : 'small'}
        className={
          repeat === repeatForMobile ? 'h-screen flex flex-col' : ''
        }
        title={title}
        onClose={(e) => setShowViewBreakup(false)}
      >
        <DataGridGroup
          data={display_data}
          textType="normal"
          severity="none"
          repeat={repeat}
          spaceY={4}
        />
      </Modal>
    </div>
  ) : (
    <div></div>
  );
}
